import React from 'react';

import api, { urlParamCharacter } from '../services/api';
import Address from '../components/Address';
import Contact from '../components/Contact';

export default class ContactsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      addresses: [],
      contacts: [],
    };
  }

  componentDidMount() {
    document.documentElement.classList.add('contacts');

    api.get(`/addresses${urlParamCharacter}orderby=menu_order&order=asc`)
      .then((response) => {
        this.setState({
          addresses: response.data,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });

    api.get(`/contacts${urlParamCharacter}orderby=menu_order&order=asc`)
      .then((response) => {
        this.setState({
          contacts: response.data,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }

  componentWillUnmount() {
    document.documentElement.classList.remove('contacts');
  }

  render() {
    const { addresses, contacts } = this.state;

    return (
      <>
        <h1 className="sr-only">Contacts</h1>
        <div className="container">
          <ul className="columns">
            {addresses.map((address) => (
              <Address
                key={address.slug}
                title={address.title.rendered}
                city={address.acf.city}
                mailOnly={address.acf.mail_only}
                address={address.acf.address}
                telephoneNumber={address.acf.telephone_number}
                faxNumber={address.acf.fax_number}
              />
            ))}
            {contacts.map((contact) => (
              <Contact
                key={contact.slug}
                title={contact.title.rendered}
                role={contact.acf.role}
                email={contact.acf.email}
                phone={contact.acf.phone}
              />
            ))}
          </ul>
        </div>
      </>
    );
  }
}
